// extracted by mini-css-extract-plugin
module.exports = {"contentDiv":"CRMAlert_contentDiv__357sk","img":"CRMAlert_img__hi63V"};